import { Box, Heading } from '@chakra-ui/layout';
import { Tabs, TabList, Tab, TabPanels, TabPanel } from '@chakra-ui/react';
import { WhitelistTab } from '../components/WhitelistTab';

export const Whitelist: React.FC<{}> = () => {
    const controller = new AbortController();
    const signal = controller.signal;

    return (
        <Box>
            <Heading>Whitelist</Heading>
            <br />
            <Heading as="h2" size="md">
                Functions
            </Heading>
            <Tabs defaultValue="members">
                <TabList>
                    <Tab>Create Session</Tab>
                </TabList>
                <TabPanels>
                    <TabPanel>
                        <WhitelistTab func="create-session" signal={signal} />
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </Box>
    );
};
